<template>
  <v-snackbar :model-value="store.message !== null" :timeout="-1" location="bottom" @update:model-value="onToggle">
    {{ store.message }}
    <template #actions>
      <v-btn variant="text" @click="store.undo()">Undo</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
  import { useUndoToastStore } from '@/store/undoToastStore';

  const store = useUndoToastStore();

  function onToggle(open: boolean): void {
    if (!open) store.dismiss();
  }
</script>
